import { h, Fragment } from "preact";

import ProductOptionSwatchList from "./product-option-swatch-list";
import ProductOptionSwatchHeader from "./product-option-swatch-header";

export default function ProductOptionSwatches({
  optionValues,
  optionName,
  optionLabel,
  updateOptionValue,
  selectedOptionValue,
  disabledOptionValues = [],
  truncate = false,
  swatchRequestUrl,
}) {
  return (
    <div
      className={`product-options__option product-options__option--swatches`}
    >
      <ProductOptionSwatchHeader
        optionName={optionName}
        optionLabel={optionLabel}
        selectedOptionValue={selectedOptionValue}
        swatchRequestUrl={swatchRequestUrl}
      />
      <div className="product-options__option-content">
        <div className="product-options__option-content-inner">
          <ProductOptionSwatchList
            legend={optionLabel}
            optionValues={optionValues}
            optionName={optionName}
            updateOptionValue={updateOptionValue}
            selectedOptionValue={selectedOptionValue}
            disabledOptionValues={disabledOptionValues}
            truncate={truncate}
          />
        </div>
      </div>
    </div>
  );
}
